import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.evidha.com/">
        www.evidha.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

const WebappFooter = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Footer */}
      <Box sx={{ bgcolor: "background.paper", p: 6 }} component="footer">
        <Typography variant="h6" align="center" gutterBottom>
          Powered by
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          color="text.secondary"
          component="p"
        >
          eVidha
        </Typography>
        <Copyright />
        <Typography variant="body2" color="text.secondary" align="center">
      {'For enquiries contact us at: '}
          <Link color="inherit" href="mailto:evidhaone@gmail.com">
             evidhaone@gmail.com
          </Link>
        </Typography>
      </Box>
      {/* End footer */}
    </ThemeProvider>
  );
};

export default WebappFooter;
